import React, { Fragment } from 'react'
import { Scrollbars } from 'react-custom-scrollbars';

import Popup from '../Popup/index';
import Registry from '../../../registry/index';
import { BobTVSiteInterfaceError } from '../../../interfaces/site/index';

class ExcludePopup extends Popup {
    constructor(props) {
        super(props);

        this.showOverlay = true;
        this.afterClosePositionReset = false;

        this.state = {
            reasons: [],
            error: '',
            details: '',
            reason_id: null,
            custom_reason: '',
            successMessage: ''
        };

        this._onSuccess = this._onSuccess.bind(this);
        this._onError = this._onError.bind(this);
    }

    exclude = user => {
        const { reason_id, custom_reason, details  } = this.state;
        const { currentRoom: { server_id, id } } = this.props;
        const { nick } = user;
        let siteInterface = Registry.get('siteInterface');

        siteInterface.excludeUser({
            nick,
            details,
            server_id,
            reason_id,
            room_id: id,
            custom_reason,
            })
            .then(res => {
                this.setState({ successMessage: res.data.message })
            })
            .catch(error => {
                this.setState({ error: error.message })
            });
    }

    componentDidMount() {
        super.componentDidMount();
        const siteInterface = Registry.get('siteInterface');
        siteInterface.getExclusionReasons()
            .then(res => {
                this.setState({ reasons: res.data.list });
            })
            .catch(err => {
                this.setState({ error: err.message });
            })
    }

    onReasonChanged = event => {
        this.setState({ reason_id: event.currentTarget.value })
    }

    _afterOpen() {
        this.setState({
            error: '',
            details: '',
            custom_reason: '',
            successMessage: '',
            reason_id: null,
        });
    }

    _onSuccess(_response) {
        this.close();
    }

    /**
     * @param {Error|BobTVSiteInterfaceError} exception
     * @private
     */
    _onError(exception) {
        let errorMessage = exception instanceof BobTVSiteInterfaceError ? exception.message : Registry.get('locale')['site_interface_generic_error'];
        this.setState({error: errorMessage});
    }

    render() {
        const { user, currentUser } = this.props;
        const { error, reasons, reason_id, custom_reason, details, successMessage } = this.state;
        const lang = Registry.get('locale');
        const isAdmin = currentUser.isAdmin();
        const small = successMessage || error;

        const className =
            `popup popup-exclude ${isAdmin ? 'admin ' : ' '} ${small ? 'small ' : ' '}` + this.state.visibility;

        return (
            <div className={className} ref={(ref) => this._ref = ref}>
                {error && <p className="error">{error}</p>}
                {successMessage && <p className="text">{successMessage}</p>}
                {!successMessage && !error && (
                    <Fragment>
                        <p className="desc bold">{lang.exclude_confirm(user)}</p>
                        <Scrollbars
                            style={{ height: 'calc(100% - 100px)', margin: '5px 0' }}
                            renderTrackVertical={props => <div {...props} className="track-vertical thin"/>}
                            renderThumbVertical={props => <div {...props} className="thumb-vertical"/>}
                        >
                            <p className="text">{lang.exclude_reason}</p>
                            <div className="reasons">
                                {reasons.map(reason => (
                                    <div className="radio" key={reason.id}>
                                        <input
                                            type="radio"
                                            id={reason.id}
                                            value={reason.id}
                                            onChange={this.onReasonChanged}
                                            checked={reason_id == reason.id}
                                        />
                                    <label htmlFor={reason.id}>{reason.title}</label>
                                    </div>
                                ))}
                            </div>
                            <textarea 
                                value={details}
                                placeholder={lang.exclude_placeholder}
                                onChange={event => this.setState({ details: event.target.value })}
                            />
                            {currentUser.isAdmin() &&
                                <textarea 
                                    value={custom_reason}
                                    placeholder={lang.exclude_placeholder_other}
                                    onChange={event => this.setState({ custom_reason: event.target.value })}
                                />
                            }
                            <div className="info-wrapper">
                                {lang.exclude_information.map((item, idx) =>
                                    <p className="info" key={idx}>{item}</p>
                                )}
                            </div>
                        </Scrollbars>
                        <a href="#" className="popup-button" onClick={() => this.exclude(user)}>{lang.exclude}</a>
                    </Fragment>
                )}
                <a href="#" className="popup-button" onClick={() => this.close()}>{lang.close}</a>
             </div>
        )
    }
}

ExcludePopup.generateKey = function() { return 'exclude-popup' };
ExcludePopup.mount = function(props, onMount) { return Popup.mount(ExcludePopup, props, onMount) };
ExcludePopup.open = function(props) {
    ExcludePopup.mount(props, () => {  Popup.popups[ExcludePopup.generateKey(props)].open(); } );
   
};

export default ExcludePopup;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/ExcludePopup/index.js